import { productApi } from "@/shared/core-products";
import { trackEvent } from "@/utils/firebase/analytics";

export const downloadLocalProductReport = async (
  id: string,
  fileName?: string,
) => {
  const report = await productApi.getLocalProductReport(id);
  const reportURL = URL.createObjectURL(report);
  const link = document.createElement("a");
  link.href = reportURL;
  link.download = fileName || `reporte-${id}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  trackEvent("export", {
    type: "xlsx",
    module: "local_products",
    product_id: id,
  });
};
